<template>
    <div class="animated fadeIn">
        <LoadingWidget
            v-if="initStatus != 1"
            :status="initStatus"
            @init="init"
        />

        <b-card v-else>
            <h5 class="mb-0">
                <i class="fa fa-fw fa-archive mr-2" />Detail Retur Inventaris
            </h5>
            <hr />
            <b-row>
                <b-col md="6">
                    No. Faktur <strong>{{ data.no_faktur }}</strong
                    ><br />
                    Status
                    <b-badge :variant="getStatusBadge(data.status)[0]">{{
                        getStatusBadge(data.status)[1]
                    }}</b-badge>
                    <br />

                    <template v-if="data.approved_at">
                        Disetujui oleh
                        <strong>{{ data.approved_by }}</strong> pada
                        <strong>
                            {{ $helper.parseDate(data.approved_at) }},
                            {{ $helper.parseHourMinute(data.approved_at) }}
                        </strong>
                        <br />
                    </template>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-button
                        v-if="data.status == 2 && invoiceLink && invoiceLinkA4"
                        id="reprint-invoice-button"
                        variant="dark"
                        @click="showReprintInvoice"
                    >
                        <i class="fa fa-print mr-2" />Cetak Invoice
                    </b-button>
                    <b-button
                        v-if="data.status == 1"
                        variant="success"
                        class="ml-2"
                        @click="finalisasiRetur"
                    >
                        <i class="fa fa-check mr-2" />Finalisasi
                    </b-button>
                </b-col>
            </b-row>

            <b-row class="mt-3">
                <b-col md="4">
                    <b-form-group label="No. Faktur">
                        <b-form-input
                            v-model="filter.no_faktur"
                            maxlength="50"
                            placeholder="Cari No. Faktur..."
                            @keydown.enter="getItems"
                        />
                    </b-form-group>
                </b-col>
                <b-col md="4">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr />
            <b-table
                bordered
                hover
                show-empty
                :busy="isBusy"
                no-local-sorting
                :items="items"
                :fields="fields"
                responsive
                @sort-changed="onSortChanged"
            >
                <template v-slot:empty>
                    Tidak ada barang.
                </template>
                <template v-slot:cell(no)="row">
                    {{ row.index + 1 }}.
                </template>
                <template v-slot:cell(barang)="row">
                    {{ row.item.type }}
                    <span v-if="row.item.year != null"
                        >({{ row.item.year }})</span
                    >
                    <div class="small text-muted">
                        {{ row.item.kind }} - {{ row.item.brand }}
                    </div>
                </template>
                <template v-slot:cell(noFakturImei)="row">
                    <div class="small">
                        NF
                        <strong
                            style="cursor:pointer;"
                            @click="copyToClipboard(row.item.no_faktur_pgi)"
                            >{{ row.item.no_faktur_pgi }}</strong
                        >
                        <i
                            style="cursor:pointer;"
                            @click="copyToClipboard(row.item.no_faktur_pgi)"
                            class="fa fa-fw fa-copy"
                        /><br />
                        IMEI
                        <strong
                            style="cursor:pointer;"
                            @click="copyToClipboard(row.item.imei_sn)"
                            >{{ row.item.imei_sn }}
                        </strong>
                        <i
                            style="cursor:pointer;"
                            @click="copyToClipboard(row.item.imei_sn)"
                            class="fa fa-fw fa-copy"
                        />
                    </div>
                </template>
            </b-table>
            <PageSizer
                :totalRows="totalRows"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>

        <b-modal
            id="m-reprint-invoice"
            title="Cetak Ulang Invoice"
            centered
            hide-footer
        >
            <div id="reprint-invoice-instructions">
                Tekan bagian "Sinar Mutiara Cell" untuk mencetak.
            </div>
            <iframe
                id="reprint-invoice-iframe"
                :src="getInvoiceLink()"
                height="300px"
                width="100%"
            />
            <div id="reprint-invoice-buttons" class="mt-4">
                <b-row>
                    <b-col md="6">
                        <b-button
                            id="reprint-invoice-toggle-size-button"
                            variant="dark"
                            :disabled="invoiceSizeCooldown"
                            @click="toggleInvoiceSize"
                        >
                            Print {{ invoiceSize == "A5" ? "A4" : "A5" }}
                        </b-button>
                    </b-col>
                    <b-col md="6" class="text-right">
                        <b-button
                            id="reprint-invoice-ok-button"
                            variant="primary"
                            @click="$bvModal.hide('m-reprint-invoice')"
                        >
                            OK
                        </b-button>
                    </b-col>
                </b-row>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    data() {
        return {
            initStatus: 0,
            isSubmitting: false,
            isBusy: false,

            filter: {
                no_faktur: ""
            },

            data: {},
            items: [],

            fields: [
                { key: "no", label: "No." },
                {
                    key: "noFakturImei",
                    label: "No. Faktur & IMEI / SN",
                    sortable: false
                },
                { key: "barang", label: "Barang", sortable: false },
                { key: "note", label: "Catatan", sortable: false }
            ],

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" }
            ],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            invoiceLink: "",
            invoiceLinkA4: "",

            invoiceSize: "A5",
            invoiceSizeCooldown: false
        };
    },

    methods: {
        init() {
            this.initStatus = 0;

            this.getItems();
        },

        getItems(page) {
            this.isBusy = true;

            if (isNaN(page)) {
                this.currentPage = 1;
            } else {
                this.currentPage = page;
            }

            let param = this.$helper.getBasePagedQuery(
                this.currentPage,
                this.perPage,
                true
            );

            if (!this.$helper.isBlank(this.filter.no_faktur)) {
                param += "&no_faktur=" + this.filter.no_faktur;
            }

            if (!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy;
                param += "&sortDesc=" + this.sortDesc;
            }

            return this.$axios
                .get("return-inventory-pgi/" + this.$route.params.id + param)
                .then(res => {
                    this.items = res.data.data.details.items;
                    this.totalRows = res.data.data.details.total;
                    this.data = res.data.data;

                    if (this.data.link && this.data.linka4) {
                        const cleanedString = this.data.link.replace(/\\/g, "");
                        const cleanedStringa4 = this.data.linka4.replace(
                            /\\/g,
                            ""
                        );

                        this.invoiceLink = `${
                            this.$BASE_PRINT_FILE_PATH
                        }${cleanedString}`;
                        this.invoiceLinkA4 = `${
                            this.$BASE_PRINT_FILE_PATH
                        }${cleanedStringa4}`;
                    } else {
                        this.invoiceLink = "";
                        this.invoiceLinkA4 = "";
                    }
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isBusy = false;
                    this.initStatus = 1;
                });
        },

        finalisasiRetur() {
            let isConfirmed = confirm(
                "Finalisasi retur ini? Proses ini tidak dapat dibatalkan!"
            );
            if (!isConfirmed) return;

            this.isSubmitting = true;

            const payload = {
                sendback_return_id: parseInt(this.$route.params.id)
            };
            this.$axios
                .post("return-inventory-pgi/finalize", payload)
                .then(() => {
                    this.$helper.toastSuccess(
                        this,
                        "Retur berhasil dijalankan!"
                    );

                    this.getItems(this.currentPage);
                })
                .catch(error => this.$helper.parseError(this, error))
                .finally(() => {
                    this.isSubmitting = false;
                });
        },

        toggleInvoiceSize() {
            this.invoiceSizeCooldown = true;
            if (this.invoiceSize == "A5") this.invoiceSize = "A4";
            else this.invoiceSize = "A5";
            setTimeout(
                function() {
                    this.invoiceSizeCooldown = false;
                }.bind(this),
                2000
            );
        },

        getInvoiceLink() {
            if (this.invoiceSize == "A5") {
                return this.invoiceLink;
            } else {
                return this.invoiceLinkA4;
            }
        },

        showReprintInvoice() {
            this.$bvModal.show("m-reprint-invoice");
        },

        copyToClipboard(text) {
            navigator.clipboard.writeText(text).then(
                () => {
                    this.$helper.toastSuccess(
                        this,
                        "Berhasil menyalin teks ke clipboard!"
                    );
                },
                () => {
                    this.$helper.toastError(
                        this,
                        "Gagal menyalin teks ke clipboard!"
                    );
                }
            );
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy;
            this.sortDesc = ctx.sortDesc;
            this.getItems();
        },

        getStatusBadge(status) {
            switch (status) {
                case 1:
                    return ["warning", "PENDING"];
                case 2:
                    return ["success", "APPROVED"];
                default:
                    return ["light", "-"];
            }
        }
    },
    created() {
        this.init();
    }
};
</script>

<style></style>
